import { render, staticRenderFns } from "./OMobibCard.vue?vue&type=template&id=65724408&"
import script from "./OMobibCard.vue?vue&type=script&lang=js&"
export * from "./OMobibCard.vue?vue&type=script&lang=js&"
import style0 from "./OMobibCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports